"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetHlOnboardingPossiblePaymentPlansQuery = void 0;
const cq_core_1 = require("@leavy/cq-core");
const validator_1 = require("@leavy/validator");
const base_1 = require("../../base");
const Currency_1 = require("@leavy/lv-homesharing-pricing-srv/lib/money/domain/Currency");
let GetHlOnboardingPossiblePaymentPlansQuery = class GetHlOnboardingPossiblePaymentPlansQuery extends cq_core_1.Query {
};
__decorate([
    (0, validator_1.IsString)(),
    __metadata("design:type", String)
], GetHlOnboardingPossiblePaymentPlansQuery.prototype, "userId", void 0);
__decorate([
    (0, validator_1.IsOptional)(),
    (0, validator_1.IsEnum)(Currency_1.Currency),
    __metadata("design:type", String)
], GetHlOnboardingPossiblePaymentPlansQuery.prototype, "currency", void 0);
GetHlOnboardingPossiblePaymentPlansQuery = __decorate([
    (0, cq_core_1.RpcInvocable)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        alias: "get_hl_onboarding_possible_payment_plans",
    })
], GetHlOnboardingPossiblePaymentPlansQuery);
exports.GetHlOnboardingPossiblePaymentPlansQuery = GetHlOnboardingPossiblePaymentPlansQuery;
//# sourceMappingURL=GetHlOnboardingPossiblePaymentPlansQuery.js.map